export default async function getCollection(ref) {
	const list = [];

	(await ref.get()).forEach((doc) => list.push(doc));

	return list;
}
